import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Popper from '@mui/material/Popper';
import { POPPER_STYLE } from './styled';

export const InlinePopper = ({ open, anchorEl, onOpen, placement, sx, testId, children }) => {
  const computedSX = useMemo(() => ({ ...POPPER_STYLE, ...sx }), [sx]);
  return (
    <Popper
      className="dsc-popper"
      data-testid={testId}
      open={open}
      anchorEl={anchorEl}
      onOpen={onOpen}
      disablePortal
      placement={placement}
      sx={computedSX}>
      {children}
    </Popper>
  );
};

InlinePopper.propTypes = {
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.any,
  onOpen: PropTypes.func,
  testId: PropTypes.string,
  placement: PropTypes.oneOf([
    'auto',
    'auto-start',
    'auto-end',
    'bottom-end',
    'bottom-start',
    'bottom',
    'left-end',
    'left-start',
    'left',
    'right-end',
    'right-start',
    'right',
    'top-end',
    'top-start',
    'top'
  ]),
  sx: PropTypes.any
};
